import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, forwardRef, isValidElement, useContext, useMemo } from 'react';
import { Field as HeadlessField } from '@flywire/react-headlessui';
import { cx } from '../../utils/cx';
import { findChildRecursively } from '../../utils/findChildRecursively';
import { Addon } from './Addon';
import { Checkbox } from './Checkbox';
import { FieldError } from './Error';
import { Group } from './Group';
import { Hint } from './Hint';
import { Input } from './Input';
import { Label } from './Label';
import { Radio } from './Radio';
import { Textarea } from './Textarea';
const FieldContext = createContext({ floatingLabel: true });
export const useFieldContext = () => {
    return useContext(FieldContext);
};
export const useFieldClasses = ({ className }) => {
    return cx('group/field flex flex-col gap-1.5 justify-center', className);
};
const FieldComponent = forwardRef(({ className, floatingLabel = true, children, ...rest }, ref) => {
    const classes = useFieldClasses({ className });
    const hasSelectionControl = useMemo(() => {
        return findChildRecursively(children, child => isValidElement(child) && (child.type === Checkbox || child.type === Radio));
    }, [children]);
    const contextValue = useMemo(() => ({ floatingLabel: hasSelectionControl ? false : floatingLabel }), [floatingLabel, hasSelectionControl]);
    return (_jsx(FieldContext.Provider, { value: contextValue, children: _jsx(HeadlessField, { ref: ref, className: classes, ...rest, children: children }) }));
});
FieldComponent.displayName = 'Field';
const Field = FieldComponent;
Field.Addon = Addon;
Field.Checkbox = Checkbox;
Field.Error = FieldError;
Field.Group = Group;
Field.Hint = Hint;
Field.Input = Input;
Field.Label = Label;
Field.Radio = Radio;
Field.Textarea = Textarea;
export { Field };
//# sourceMappingURL=Field.js.map